module.exports = __webpack_public_path__ + "img/article6.dddac26d.jpg";